import { useBelongsToMyCompany } from '@/features/company/hooks';

import { AboutTheSellerBox } from '../about-seller/about-the-seller-box';
import { SaleProcessBox } from '../sale-process/sale-process-box';
import { SaleProcessNewDrawer } from '../sale-process/sale-process-drawer-new';
import { useState } from 'react';
import { AboutSellerNewDrawer } from '../about-seller/about-seller-drawer-new';
import { useUpdateOpportunity } from '@/features/projects/hooks/use-update-opportunity';
import { useOpportunityDetails } from '../../../hooks';

export type OpportunityTabDetailsProps = { readonly opportunityId: string };

export function OpportunityDetails({ opportunityId }: OpportunityTabDetailsProps) {
  const [drawer, setDrawer] = useState<string | null>(null);
  const { normalizedOpportunity, opportunity } = useOpportunityDetails(opportunityId);

  if (!normalizedOpportunity) return null;
  if (!opportunity) return null;

  const opportunityBelongsToMyCompany = useBelongsToMyCompany(opportunity?.company);

  const isEditable = !!(opportunityBelongsToMyCompany && normalizedOpportunity?.isDraft);

  const { onSubmitOpportunity } = useUpdateOpportunity({
    opportunityId: opportunity.id,
    setDrawer,
  });

  return (
    <div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <SaleProcessBox
          opportunity={normalizedOpportunity}
          onEdit={isEditable ? () => setDrawer(`sale-process-detail-${opportunity.id}`) : undefined}
          isEditable={isEditable}
        />
        <AboutTheSellerBox
          opportunity={normalizedOpportunity}
          onEdit={isEditable ? () => setDrawer(`about-seller-${opportunity.id}`) : undefined}
          isEditable={isEditable}
        />
      </div>

      <SaleProcessNewDrawer
        opportunity={normalizedOpportunity}
        formId={`sale-process-detail-${opportunity.id}`}
        onSubmit={(data, description) => onSubmitOpportunity(data)}
        isOpen={drawer == `sale-process-detail-${opportunity.id}`}
        onClose={() => setDrawer(null)}
      />

      <AboutSellerNewDrawer
        opportunity={normalizedOpportunity}
        formId={`about-seller-${opportunity.id}`}
        onSubmit={(data, description) => onSubmitOpportunity(data)}
        isOpen={drawer == `about-seller-${opportunity.id}`}
        onClose={() => setDrawer(null)}
      />
    </div>
  );
}
